module.exports = __webpack_public_path__ + "static/media/qrct-bcrre-university-of-birmingham.d29f0f89.jpg";